<template>
  <div>
    <div class="veil" v-show="isSettingsModalVisible"></div>
    <div class="modal" v-show="isSettingsModalVisible">
      <div class="form">
        <label for="width_in_inches"><span>Table dimensions (in):</span>
          <input id="width_in_inches" type="number" v-model="widthInInches">
          <div style="margin-left: 7px;">x</div>
          <input id="height_in_inches" type="number" v-model="heightInInches">
        </label>
        <!--        <label for="attacker_edge"><span>Attacker edge:</span> <select id="attacker_edge" v-model="attackerEdge">-->
        <!--          <option :value="TableEdges.N">North</option>-->
        <!--          <option :value="TableEdges.E">East</option>-->
        <!--          <option :value="TableEdges.S">South</option>-->
        <!--          <option :value="TableEdges.W">West</option>-->
        <!--        </select>-->
        <!--        </label>-->
        <div class="separator">Attacker</div>
        <label for="attacker_max_distance">
          <span>Max patrol marker movement distance (in):</span>
          <input id="attacker_max_distance" type="number" v-model="attackerMaxDistance">
        </label>
        <table>
          <thead>
          <tr>
            <th>Group #</th>
            <th>Patrol markers</th>
            <th>Table edge</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(markerGroup,i) in attacker" v-bind:key="markerGroup.id">
            <td>{{ i + 1 }}</td>
            <td><input id="attacker_marker_groups_1" type="number" v-model="markerGroup.markerCount"></td>
            <td>
              <select id="attacker_marker_groups_1_edge" v-model="markerGroup.tableEdge">
                <option :value="TableEdges.N">North</option>
                <option :value="TableEdges.E">East</option>
                <option :value="TableEdges.S">South</option>
                <option :value="TableEdges.W">West</option>
              </select>
            </td>
            <td>
              <button v-show="attacker.length === 1" class="muted" @click="addMarkerGroup(attacker)">
                <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m8.0273 37.426h29.398v-29.398c0-8.9727 25.148-8.9727 25.148 0v29.398h29.398c8.9727 0 8.9727 25.148 0 25.148h-29.398v29.398c0 8.9727-25.148 8.9727-25.148 0v-29.398h-29.398c-8.9727 0-8.9727-25.148 0-25.148z"
                      fill-rule="evenodd"/>
                </svg>
              </button>
              <button v-show="attacker.length === 2 && i === 1" class="muted" @click="removeMarkerGroup(markerGroup)">
                <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m32.398 50.602l-22.398-23.203c-5-5-5-12.398 0-17.398s12.398-5 17.398 0l22.398 22.398 22.402-22.398c5-5 13.301-5 18.199 0 5 5 5 13.301 0 18.199l-22.398 22.402 22.398 22.398c5 5 5 12.398 0 17.398s-12.398 5-17.398 0l-22.398-22.398-22.402 22.398c-5 5-13.301 5-18.199 0-5-5-5-13.301 0-18.199z"/>
                </svg>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="separator">Defender</div>
        <label for="defender_max_distance">
          <span>Max patrol marker movement distance (in):</span>
          <input id="defender_max_distance" type="number" v-model="defenderMaxDistance">
        </label>
        <table>
          <thead>
          <tr>
            <th>Group #</th>
            <th>Patrol markers</th>
            <th>Table edge</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(markerGroup,i) in defender" v-bind:key="markerGroup.id">
            <td>{{ i + 1 }}</td>
            <td><input id="defender_marker_groups_1" type="number" v-model="markerGroup.markerCount"></td>
            <td>
              <select id="defender_marker_groups_1_edge" v-model="markerGroup.tableEdge">
                <option :value="TableEdges.N">North</option>
                <option :value="TableEdges.E">East</option>
                <option :value="TableEdges.S">South</option>
                <option :value="TableEdges.W">West</option>
              </select>
            </td>
            <td>
              <button v-show="defender.length === 1" class="muted" @click="addMarkerGroup(defender)">
                <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m8.0273 37.426h29.398v-29.398c0-8.9727 25.148-8.9727 25.148 0v29.398h29.398c8.9727 0 8.9727 25.148 0 25.148h-29.398v29.398c0 8.9727-25.148 8.9727-25.148 0v-29.398h-29.398c-8.9727 0-8.9727-25.148 0-25.148z"
                      fill-rule="evenodd"/>
                </svg>
              </button>
              <button v-show="defender.length === 2 && i === 1" class="muted" @click="removeMarkerGroup(markerGroup)">
                <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m32.398 50.602l-22.398-23.203c-5-5-5-12.398 0-17.398s12.398-5 17.398 0l22.398 22.398 22.402-22.398c5-5 13.301-5 18.199 0 5 5 5 13.301 0 18.199l-22.398 22.402 22.398 22.398c5 5 5 12.398 0 17.398s-12.398 5-17.398 0l-22.398-22.398-22.402 22.398c-5 5-13.301 5-18.199 0-5-5-5-13.301 0-18.199z"/>
                </svg>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="separator">Shaded area</div>
        <label>
          <div><input type="checkbox" v-model="isShadedAreaEnabled">Enable</div>
          <div v-if="shadedArea != null" class="shaded-area-inputs">
            <span>Left</span>
            <input type="number" v-model="shadedArea.x" placeholder="Left (in)">
            <span>Top</span>
            <input type="number" v-model="shadedArea.y" placeholder="Right (in)">
            <span>Width</span>
            <input type="number" v-model="shadedArea.width" placeholder="Width (in)">
            <span>Height</span>
            <input type="number" v-model="shadedArea.height" placeholder="Height (in)">
          </div>
        </label>

        <div class="buttons">
          <button @click="() => { isSettingsModalVisible = false; reset(); }">OK</button>
          <button @click="() => { isSettingsModalVisible = false; cancel(); }">Cancel</button>
        </div>
      </div>
    </div>
    <div v-if="image != null"
         class="form" style="height: 40px;">
      <template v-if="phase == 'MOVE_DEFENDER_MARKERS' || phase == 'MOVE_ATTACKER_MARKERS' || phase == 'ADD_ATTACKER_JOP' || phase == 'ADD_DEFENDER_JOP'">
        <span v-if="phase == 'MOVE_ATTACKER_MARKERS'" class="info">Click on the map to move all attacker markers.</span>
        <span v-else="" class="info">Click on the map to move all defender markers.</span>
        <a style="margin-left: 0.6rem;" @click="() => { phase = 'PATROL'; }">Cancel</a>
      </template>
      <template v-else="">
        <button :disabled="states.length <= 1" :class="{disabled: states.length <= 1}" @click="() => { undo(); }">
          <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 138" viewBox="0 0 100 100" x="0px" y="0px">
            <g>
              <path class="cls-1"
                    d="M94.83,50A44.81,44.81,0,0,0,17.12,19.56V11.15a6,6,0,1,0-12,0v23.9a6,6,0,0,0,6,6H35.06a6,6,0,0,0,0-12H24.64A32.88,32.88,0,1,1,50,82.87h0a6,6,0,1,0,0,12h.12A44.82,44.82,0,0,0,94.83,50Z"></path>
            </g>
          </svg>
          Undo
        </button>
        <button :disabled="redoStates.length === 0" :class="{disabled: redoStates.length === 0}" @click="() => { redo(); }">
          <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 138" viewBox="0 0 100 100" x="0px" y="0px">
            <g>
              <path class="cls-1"
                    d="M88.86,5.16a6,6,0,0,0-6,6v8.42a44.82,44.82,0,1,0-33,75.26l.12,0a6,6,0,0,0,0-12h0a32.88,32.88,0,1,1,25.36-53.8H64.94a6,6,0,0,0,0,12H88.86a6,6,0,0,0,6-6V11.14A6,6,0,0,0,88.86,5.16Z"></path>
            </g>
          </svg>
          Redo
        </button>
        <button @click="() => { reset(); }">
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m100 50c0 27.613-22.387 49.996-50 49.996s-50-22.383-50-49.996c0-22.754 15.199-41.953 36-48.008v14.371c-13.168 5.4922-22.426 18.48-22.426 33.637 0 20.117 16.309 36.422 36.426 36.422s36.426-16.305 36.426-36.422c0-15.211-9.3242-28.242-22.57-33.695v-14.355c20.875 6.0078 36.145 25.242 36.145 48.051zm-43.238-43.16c0-3.7734-3.0625-6.8359-6.8359-6.8359-3.7734 0-6.8359 3.0625-6.8359 6.8359v35.789c0 3.7734 3.0625 6.8359 6.8359 6.8359 3.7734 0 6.8359-3.0625 6.8359-6.8359z"/>
          </svg>
          Reset
        </button>
        <button @click="() => { isSettingsModalVisible = true; }">
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m98.719 38.73c-0.12891-0.32812-0.30078-0.63672-0.50781-0.92188-1.8008-2.3086-4.6055-3.6055-7.5312-3.4883h-0.50781c-1.6797-0.042968-3.207-0.98047-4-2.4609-0.082031 0.007813-0.14844-0.058594-0.14062-0.14062-0.53125-0.92188-1-1.6797-1.5391-2.6016l-0.003907 0.003906c-0.054687-0.015625-0.09375-0.0625-0.097656-0.12109-0.89453-1.4609-0.94531-3.2891-0.14062-4.8008 0.13281-0.089844 0.22266-0.23047 0.25-0.39062 1.5273-2.5898 1.8047-5.7305 0.76172-8.5469-0.097657-0.34375-0.27344-0.65625-0.51172-0.92188-1.7031-1.6094-3.4922-3.125-5.3594-4.5391-0.25-0.12109-0.53125-0.25-0.89844-0.39062h-0.003907c-2.9219-0.60156-5.957 0.21875-8.1797 2.2109-0.14453 0.039062-0.27344 0.12891-0.36719 0.25-0.78516 0.66406-1.7852 1.0234-2.8125 1-0.61719-0.011719-1.2305-0.14453-1.8008-0.39062-0.94922-0.40625-1.9297-0.74219-2.9297-1-1.5977-0.57031-2.7656-1.957-3.0586-3.6289-0.027344-0.17578-0.074219-0.34766-0.14062-0.51172-0.375-2.9883-2.1914-5.6055-4.8594-7-0.26953-0.15625-0.57812-0.23828-0.89062-0.23828-2.293-0.13672-4.5938-0.13672-6.8906 0-0.3125 0.027344-0.61719 0.11328-0.89844 0.25-2.6641 1.4609-4.4688 4.1055-4.8594 7.1172-0.10938 0.10156-0.16016 0.24609-0.14062 0.39062-0.26172 1.6875-1.4414 3.0898-3.0586 3.6289-0.87891 0.25-1.9102 0.64062-2.9297 1-0.59375 0.14453-1.1953 0.22656-1.8008 0.25-1.0234-0.007812-2.0117-0.35938-2.8125-1-0.12109-0.14062-0.25-0.14062-0.37109-0.26953h0.003906c-2.2188-2-5.2578-2.8203-8.1797-2.207-0.33984 0.007812-0.66406 0.14844-0.90234 0.38672-1.9336 1.332-3.7344 2.8477-5.3711 4.5312-0.21094 0.28125-0.38281 0.58984-0.50781 0.92187-1.0977 2.8086-0.81641 5.9727 0.75781 8.5469 0.097657 0.125 0.17969 0.25391 0.25 0.39062 0.80469 1.5156 0.75 3.3359-0.13672 4.8008-0.082031-0.007813-0.14844 0.058594-0.14062 0.14062-0.55078 0.82812-1.0391 1.6992-1.4609 2.5977-0.078125-0.003906-0.14453 0.0625-0.14062 0.14062-0.75 1.5195-2.3047 2.4766-4 2.4609h-0.51953c-2.9219-0.074219-5.707 1.2227-7.5312 3.5117-0.23828 0.26172-0.41016 0.57812-0.50781 0.91797-0.61328 2.3867-1.0469 4.8125-1.3008 7.2617-0.015625 0.33984 0.03125 0.67578 0.14062 1 0.94922 2.75 3.1094 4.9141 5.8594 5.8672 0.17188 0.035157 0.34375 0.082031 0.51172 0.14062 1.5859 0.55469 2.7227 1.9609 2.9297 3.6328v0.14062-0.003906c0.097656 1.0117 0.26953 2.0156 0.50781 3v0.14062c0.28906 1.6758-0.28906 3.3789-1.5391 4.5312-0.14844 0.042969-0.27734 0.12891-0.37109 0.25-2.2383 1.8086-3.5469 4.5234-3.5703 7.3984 0.03125 0.34375 0.11719 0.68359 0.25 1 1.125 2.293 2.4062 4.5039 3.832 6.6211 0.11719 0.37109 0.40625 0.66406 0.77734 0.78125 2.4531 1.375 5.3945 1.5625 8 0.50781 0.18359 0.039063 0.375-0.015625 0.51172-0.14062 0.49609-0.16797 1.0156-0.25391 1.5391-0.25 0.5625 0 1.1172 0.097657 1.6406 0.29297 0.55469 0.21094 1.0742 0.50781 1.5391 0.87891l2.3008 2 0.14062 0.14062c1.2852 1.0703 1.9141 2.7344 1.6602 4.3906-0.097656 0.15234-0.14453 0.32812-0.14062 0.50781-0.57812 2.7695 0.082031 5.6562 1.8008 7.9023 0.25 0.27734 0.55469 0.49609 0.89844 0.63672 2.332 1.1562 4.7812 2.0664 7.3008 2.7109 0.37109 0.13672 0.77734 0.13672 1.1523 0 2.7383-0.55859 5.082-2.3203 6.3789-4.8008 0.09375-0.12109 0.17578-0.25 0.25-0.38672 0.76562-1.5391 2.3867-2.457 4.0977-2.3203h3.2031c1.6875-0.042968 3.2656 0.84766 4.0977 2.3203 0.09375 0.12109 0.17969 0.25 0.25 0.38672 1.2969 2.4805 3.6406 4.2422 6.3789 4.8008h0.51172c0.14062 0 0.37109 0 0.21094-0.26953 2.4766-0.77344 4.9062-1.6836 7.2773-2.7305 0.34766-0.13672 0.65625-0.35938 0.90234-0.64062 1.3711-1.625 2.1094-3.6914 2.0898-5.8203 0-0.60938-0.0625-1.2188-0.17969-1.8164 0.019531-0.26953-0.03125-0.53906-0.14062-0.78125-0.20703-1.6445 0.47656-3.2734 1.8008-4.2695-0.13281-0.13281 0.066407-0.33594 0.19922-0.19922 0.82031-0.60156 1.5898-1.2734 2.3008-2h0.14062c0.83594-0.76172 1.9258-1.1797 3.0586-1.1719 0.375-0.003906 0.74609 0.042969 1.1094 0.14062 0.14844 0.03125 0.29297 0.078125 0.42969 0.14062 0.17578 0.03125 0.34375 0.078125 0.51172 0.14062 0.54688 0.19922 1.1055 0.35938 1.6797 0.46875 0.58594 0.11719 1.1836 0.17578 1.7812 0.17969 1.6094 0.015626 3.1992-0.39062 4.6094-1.1719l0.78125-0.78125-0.003906 0.003906c1.5039-2.0703 2.7852-4.2891 3.832-6.6211 0.15625-0.30859 0.24219-0.65234 0.25-1-0.050781-2.8711-1.3555-5.5742-3.5703-7.3984-0.12109-0.12109-0.25-0.25-0.37109-0.39062-1.1719-0.97656-1.7539-2.4922-1.5391-4v-0.15234c0.23828-0.98438 0.41016-1.9883 0.51172-3v-0.10938c0.48828-2.9609 2.6797-3.6992 2.9375-3.6992 0.20312 0.039062 0.41016-0.027344 0.55078-0.17969 2.7383-0.9375 4.8867-3.0859 5.8281-5.8203 0.10938-0.32031 0.16016-0.66016 0.14062-1-0.21484-2.4531-0.63281-4.8867-1.25-7.2695zm-48.719 32.379c-5.4492 0.046875-10.695-2.0781-14.578-5.9062-3.8828-3.8242-6.0859-9.0391-6.1211-14.488-0.035156-5.4531 2.0977-10.691 5.9297-14.57 3.8359-3.875 9.0508-6.0664 14.504-6.0938 5.4492-0.027343 10.688 2.1172 14.559 5.957 3.8672 3.8398 6.0508 9.0625 6.0664 14.512 0.050781 5.4375-2.0703 10.668-5.8945 14.535-3.8203 3.8633-9.0273 6.043-14.465 6.0547z"/>
          </svg>
          Settings
        </button>
        <label class="upload" style="margin-right: 16px;">
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path
                  d="m34.199 33 9.6992-9.6992v42.801c0 3.3984 2.6992 6.1016 6.1016 6.1016 3.3984 0 6.1016-2.6992 6.1016-6.1016v-42.902l9.6992 9.6992c1.1992 1.1992 2.6992 1.8008 4.3008 1.8008 1.6016 0 3.1016-0.60156 4.3008-1.8008 2.3984-2.3984 2.3984-6.1992 0-8.6016l-20.102-19.996c-2.3984-2.3984-6.1992-2.3984-8.6016 0l-20.098 20.098c-2.3984 2.3984-2.3984 6.1992 0 8.6016 2.3984 2.3984 6.1992 2.3984 8.5977 0z"/>
              <path
                  d="m86.199 62.801c-3.3984 0-6.1016 2.6992-6.1016 6.1016v16.5l-60.297-0.003906v-16.5c0-3.3984-2.6992-6.1016-6.1016-6.1016-3.3984 0-6.1016 2.6992-6.1016 6.1016v22.602c0 3.3984 2.6992 6.1016 6.1016 6.1016h72.5c3.3984 0 6.1016-2.6992 6.1016-6.1016v-22.602c0-3.3984-2.6992-6.0977-6.1016-6.0977z"/>
            </g>
          </svg>
          Upload map
          <input type="file" @change="(e) => { handleFileUpload(e); }">
        </label>
        <button @click="() => { isMenuOpen = true; }">...
          <div v-if="isMenuOpen"
               class="menu-bg"
               @click.stop="closeMenu"></div>
          <ul v-if="isMenuOpen">
            <li @click.stop="() => { closeMenu(); downloadImage(); }">Download screenshot</li>
            <li @click.stop="() => { closeMenu(); moveAttackerMarkers(); }">Move all <span class="attacker">attacker</span> markers</li>
            <li @click.stop="() => { closeMenu(); moveDefenderMarkers(); }">Move all <span class="defender">defender</span> markers</li>
            <li @click.stop="() => { closeMenu(); addAttackerJOP(); }">Add <span class="attacker">attacker</span> JOP</li>
            <li @click.stop="() => { closeMenu(); addDefenderJOP(); }">Add <span class="defender">defender</span> JOP</li>
          </ul>
        </button>
        <button @click="() => { isDiceMenuOpen = true; }">
          <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m77 14h-54c-4.9727 0-9 4.0273-9 9v54c0 4.9727 4.0273 9 9 9h54c4.9727 0 9-4.0273 9-9v-54c0-4.9727-4.0273-9-9-9zm-45 63c-4.9727 0-9-4.0273-9-9s4.0273-9 9-9 9 4.0273 9 9-4.0273 9-9 9zm18-18c-4.9727 0-9-4.0273-9-9s4.0273-9 9-9 9 4.0273 9 9-4.0273 9-9 9zm18-18c-4.9727 0-9-4.0273-9-9s4.0273-9 9-9 9 4.0273 9 9-4.0273 9-9 9z"/>
          </svg>
          Roll dice
          <div
              v-if="isDiceMenuOpen"
              class="menu-bg"
              @click.stop="() => { isDiceMenuOpen = false; }"></div>
          <ul v-if="isDiceMenuOpen">
            <li @click.stop="() => { isDiceMenuOpen = false; rollDice(1); }">Roll 1 die</li>
            <li @click.stop="() => { isDiceMenuOpen = false; rollDice(2); }">Roll 2 dice</li>
            <li @click.stop="() => { isDiceMenuOpen = false; rollDice(3); }">Roll 3 dice</li>
            <li @click.stop="() => { isDiceMenuOpen = false; rollDice(4); }">Roll 4 dice</li>
            <li @click.stop="() => { isDiceMenuOpen = false; rollDice(5); }">Roll 5 dice</li>
          </ul>
        </button>
        <div class="dice">
          <dice v-for="(die, i) in dice"
                v-bind:key="i"
                :roll="die"></dice>
        </div>
      </template>
    </div>
    <div class="map">
      <canvas id="canvas"
              :style="canvasStyle"
              v-if="image != null"
              :class="{ portrait: isPortrait }"
              @mousemove="canvasMouseMove"
              @touchmove="canvasMouseMove"
              @mousedown="canvasMouseDown"
              @touchstart="canvasMouseDown"
              @mouseup="canvasMouseUp"
              @touchend="canvasMouseUp"
              @mouseenter="() => { isDrawingCrosshair = true; canvasMouseMove(); }"
              @mouseleave="canvasMouseLeave"></canvas>
      <label v-else="" for="file_upload">
        <input type="file" id="file_upload" @change="(e) => handleFileUpload(e)">
        Click to upload a map</label>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import TableEdges from '@/models/TableEdges';
import PatrolMarker from '@/models/PatrolMarker';
import MarkerGroup from '@/models/MarkerGroup';
import JumpOffPoint from '@/models/JumpOffPoint';
import ShadedArea from '@/models/ShadedArea';
import Dice from '@/components/Dice';

export default {
  name: 'Main',
  props: {
    msg: String,
  },
  components: {
    Dice,
  },
  data() {
    return {
      attacker: [new MarkerGroup([], TableEdges.N)],
      attackerJOPs: [],
      attackerMaxDistance: 12,
      defender: [new MarkerGroup([], TableEdges.S)],
      defenderJOPs: [],
      defenderMaxDistance: 12,
      dice: [],
      heightInInches: 48,
      image: null,
      isDiceMenuOpen: false,
      isDrawingCrosshair: false,
      isLoaded: false,
      isMenuOpen: false,
      isPortrait: false,
      isShadedAreaEnabled: false,
      isSettingsModalVisible: false,
      jopIndex: 0,
      lastMarkerClicked: null,
      markerBeingDragged: null,
      markerDraggedFrom: null,
      markerForJOP: null,
      newX: null,
      newY: null,
      phase: 'PATROL', // or 'JOP';
      redoStates: [],
      shadedArea: null,
      states: [],
      TableEdges,
      widthInInches: 72,
      windowHeight: 1,
      windowWidth: 1,
    };
  },
  computed: {
    pixelPerInch() {
      const targetSize = 1500;
      return Math.max(targetSize / this.widthInInches, targetSize / this.heightInInches);
    },
    canvasStyle() {
      const availableRatio = this.windowWidth / this.windowHeight;
      const ratio = this.widthInInches / this.heightInInches;
      if (ratio >= availableRatio) {
        return `width: 90vw; height: ${90 / ratio}vw`;
      } else {
        return `width: ${90 * ratio}vh; height: 90vh`;
      }
    },
    markers() {
      return [
        ...this.attackerMarkers,
        ...this.defenderMarkers,
      ];
    },
    jopMarkers() {
      return [
        ...this.attackerJOPs,
        ...this.defenderJOPs,
      ];
    },
    attackerMarkers() {
      return this.attacker.map(x => x.patrolMarkers).flat();
    },
    defenderMarkers() {
      return this.defender.map(x => x.patrolMarkers).flat();
    },
  },
  methods: {
    cancel() {
      this.applyState();
    },
    reset() {
      this.states = [];
      this.redoStates = [];
      this.attackerJOPs = [];
      this.defenderJOPs = [];
      this.phase = 'PATROL';
      this.attacker.forEach((markerGroup) => {
        markerGroup.patrolMarkers = [];
        this.addMarkers(markerGroup, markerGroup.markerCount);
      });
      this.defender.forEach((markerGroup) => {
        markerGroup.patrolMarkers = [];
        this.addMarkers(markerGroup, markerGroup.markerCount);
      });
      this.drawImageAndGrid();
      this.pushState();
    },
    undo() {
      if (this.states.length > 1) {
        this.popState();
      }
    },
    redo() {
      const state = this.redoStates.pop();
      this.states.push(state);
      window.localStorage.states = JSON.stringify(this.states);
      window.localStorage.redoStates = JSON.stringify(this.redoStates);
      this.applyState();
    },
    pushState(state) {
      this.redoStates = [];
      if (state != null) {
        this.states.push(state);
      } else {
        this.states.push({
          isDrawingCrosshair: this.isDrawingCrosshair,
          isPortrait: this.isPortrait,
          jopIndex: this.jopIndex,
          heightInInches: this.heightInInches,
          widthInInches: this.widthInInches,
          windowWidth: this.windowWidth,
          windowHeight: this.windowHeight,
          attacker: this.attacker.map(x => x.toApi()),
          defender: this.defender.map(x => x.toApi()),
          markerDraggedFrom: this.markerDraggedFrom,
          markerBeingDragged: this.markerBeingDragged != null ? this.markerBeingDragged.id : null,
          phase: this.phase,
          markerForJOP: this.markerForJOP != null ? this.markerForJOP.id : null,
          attackerJOPs: this.attackerJOPs.map(x => x.toApi()),
          defenderJOPs: this.defenderJOPs.map(x => x.toApi()),
          lastMarkerClicked: this.lastMarkerClicked != null ? this.lastMarkerClicked.id : null,
          attackerEdge: this.attackerEdge,
          defenderEdge: this.defenderEdge,
          shadedArea: this.shadedArea != null ? this.shadedArea.toApi() : null,
        });
        window.localStorage.states = JSON.stringify(this.states);
        window.localStorage.redoStates = JSON.stringify(this.redoStates);
      }
    },
    popState() {
      this.redoStates.push(this.states.pop());
      this.applyState();
      window.localStorage.states = JSON.stringify(this.states);
      window.localStorage.redoStates = JSON.stringify(this.redoStates);
    },
    applyState() {
      if (this.states.length > 0) {
        const state = this.states[this.states.length - 1];
        this.isDrawingCrosshair = state.isDrawingCrosshair;
        this.isPortrait = state.isPortrait;
        this.jopIndex = state.jopIndex;
        this.heightInInches = state.heightInInches;
        this.widthInInches = state.widthInInches;
        this.windowWidth = state.windowWidth;
        this.windowHeight = state.windowHeight;
        this.attacker = state.attacker.map(x => MarkerGroup.fromApi(x));
        this.defender = state.defender.map(x => MarkerGroup.fromApi(x));
        this.markerDraggedFrom = state.markerDraggedFrom;
        this.markerBeingDragged = state.markerBeingDragged != null ? this.patrolMarkers.find(x => x.id === state.markerBeingDragged) : null;
        this.phase = state.phase;
        this.markerForJOP = state.markerForJOP != null ? this.markerForJOP.id : null;
        this.attackerJOPs = state.attackerJOPs.map(x => JumpOffPoint.fromApi(x, this.attackerMarkers));
        this.defenderJOPs = state.defenderJOPs.map(x => JumpOffPoint.fromApi(x, this.defenderMarkers));
        this.lastMarkerClicked = state.lastMarkerClicked != null ? this.patrolMarkers.find(x => x.id === state.lastMarkerClicked) : null;
        this.isShadedAreaEnabled = state.shadedArea != null;
        this.shadedArea = state.shadedArea != null ? ShadedArea.fromApi(state.shadedArea) : null;
        this.drawImageAndGrid();
      }
    },
    drawImageAndGrid(shouldDrawMinorGridLines = false, shouldDrawMajorGridLines = false) {
      const canvas = document.getElementById('canvas');
      if (canvas == null || this.widthInInches === 0 || this.heightInInches === 0) {
        return;
      }
      const canvasWidth = this.widthInInches * this.pixelPerInch;
      const canvasHeight = this.heightInInches * this.pixelPerInch;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(this.image, 0, 0, canvasWidth, canvasHeight);

      const xInch = canvasWidth / this.widthInInches;
      const yInch = canvasHeight / this.heightInInches;
      //
      // Draw minor grid lines.
      //
      if (shouldDrawMinorGridLines) {
        ctx.lineWidth = 2;
        ctx.strokeStyle = '#ffffff66';
        ctx.beginPath();
        for (let x = 1; x < this.widthInInches; x += 1) {
          ctx.moveTo(x * xInch, 0);
          ctx.lineTo(x * xInch, canvasHeight);
        }
        for (let y = 1; y < this.heightInInches; y += 1) {
          ctx.moveTo(0, y * yInch);
          ctx.lineTo(canvasWidth, y * yInch);
        }
        ctx.closePath();
        ctx.stroke();
      }
      //
      // Draw major grid lines.
      //
      if (shouldDrawMajorGridLines) {
        ctx.beginPath();
        ctx.lineWidth = 3;
        ctx.strokeStyle = 'red';
        for (let x = 12; x < this.widthInInches; x += 12) {
          ctx.moveTo(x * xInch, 0);
          ctx.lineTo(x * xInch, canvasHeight);
        }
        for (let y = 12; y < this.heightInInches; y += 12) {
          ctx.moveTo(0, y * yInch);
          ctx.lineTo(canvasWidth, y * yInch);
        }
        ctx.closePath();
        ctx.stroke();
      }

      //
      // Draw shaded area.
      //
      if (this.shadedArea != null) {
        ctx.lineWidth = 5;
        ctx.strokeStyle = '#ffffff';
        ctx.fillStyle = '#ffffff33';
        ctx.beginPath();
        // ctx.arc(m.x * this.pixelPerInch, m.y * this.pixelPerInch, 12 * this.pixelPerInch, 0, Math.PI * 2, true);
        ctx.moveTo(this.shadedArea.x * xInch, this.shadedArea.y * yInch);
        ctx.lineTo(this.shadedArea.x * xInch, (this.shadedArea.y + this.shadedArea.height) * yInch);
        ctx.lineTo((this.shadedArea.x + this.shadedArea.width) * xInch, (this.shadedArea.y + this.shadedArea.height) * yInch);
        ctx.lineTo((this.shadedArea.x + this.shadedArea.width) * xInch, this.shadedArea.y * yInch);
        ctx.lineTo(this.shadedArea.x * xInch, this.shadedArea.y * yInch);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
      }

      //
      // Draw original position of marker being dragged.
      //
      if (this.markerBeingDragged != null) {
        ctx.lineWidth = 10;
        ctx.strokeStyle = '#ffffff99';
        ctx.setLineDash([5, 10]);
        ctx.beginPath();
        ctx.moveTo(this.markerDraggedFrom.x, this.markerDraggedFrom.y);
        ctx.lineTo(this.markerBeingDragged.x * this.pixelPerInch, this.markerBeingDragged.y * this.pixelPerInch);
        ctx.closePath();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(this.markerDraggedFrom.x, this.markerDraggedFrom.y, 2 * this.pixelPerInch, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(this.markerDraggedFrom.x, this.markerDraggedFrom.y, this.getMaxDistance() * this.pixelPerInch, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.stroke();
      }

      ctx.setLineDash([]);
      ctx.strokeStyle = 'white';

      //
      // Draw dotted circles around markers
      //
      ctx.lineWidth = 3;
      ctx.strokeStyle = '#ffffff';
      ctx.setLineDash([5, 10]);

      if (this.markerDraggedFrom != null && this.markerBeingDragged != null) {
        this.closestMarkers.forEach((m) => {
          ctx.beginPath();
          ctx.arc(m.x * this.pixelPerInch, m.y * this.pixelPerInch, this.getMaxDistance() * this.pixelPerInch, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.stroke();
        });

        if (this.closestEnemies != null) {
          this.closestEnemies.forEach((m) => {
            ctx.beginPath();
            ctx.arc(m.marker.x * this.pixelPerInch, m.marker.y * this.pixelPerInch, 12 * this.pixelPerInch, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.stroke();
          });
        }
      }


      //
      // Draw line between marker being dragged and markers within 12"
      //
      if (this.friendsWithinMaxDistance != null) {
        ctx.lineWidth = 10;
        ctx.strokeStyle = '#41d763';
        this.friendsWithinMaxDistance.forEach((m) => {
          ctx.beginPath();
          // ctx.arc(m.x * this.pixelPerInch, m.y * this.pixelPerInch, 12 * this.pixelPerInch, 0, Math.PI * 2, true);
          ctx.moveTo(m.x * xInch, m.y * yInch);
          ctx.lineTo(this.markerBeingDragged.x * xInch, this.markerBeingDragged.y * yInch);
          ctx.closePath();
          ctx.stroke();
        });
      }

      //
      // Draw markers
      //
      ctx.setLineDash([]);
      ctx.lineWidth = 10;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = 20;

      const drawMarkers = (side, fill) => {
        let markerIndex = 1;
        side.forEach((markerGroup) => {
          markerGroup.patrolMarkers.forEach((marker) => {
            ctx.fillStyle = fill;
            let color = 'white';
            if (marker.isLocked) {
              color = 'yellow';
            } else if (this.closestEnemies != null && this.closestEnemies.some(x => x.marker === marker)) {
              color = 'red';
            } else if (this.friendsWithinMaxDistance != null && this.friendsWithinMaxDistance.includes(marker)) {
              color = '#41d763';
            }
            ctx.strokeStyle = color;
            const x = marker.x * this.pixelPerInch;
            const y = marker.y * this.pixelPerInch;
            ctx.beginPath();
            ctx.arc(x, y, 2 * this.pixelPerInch, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.stroke();
            ctx.fill();

            ctx.fillStyle = 'white';
            ctx.font = 'bold 64px sans-serif';
            ctx.beginPath();
            ctx.fillText(`${markerIndex}`, x - 18, y + 20);
            ctx.closePath();
            markerIndex += 1;
          });
        });
      };

      drawMarkers(this.attacker, '#FF000099');
      drawMarkers(this.defender, '#0000FF99');

      if (this.phase === 'JOP' || this.phase === 'ADD_ATTACKER_JOP' || this.phase === 'ADD_DEFENDER_JOP') {
        //
        // Draw jop lines
        //
        if (this.markerForJOP != null) {
          //
          // Draw lines for placing JOP
          //
          if (this.markerForJOP.patrolMarker != null) {
            const p1 = this.markerForJOP.patrolMarker;
            const p2 = this.markerForJOP.patrolMarker.closestEnemies[0].marker;
            const p3 = this.markerForJOP.patrolMarker.closestEnemies[1].marker;
            const distance1 = this.widthInInches * this.heightInInches;
            const angle1 = Math.atan2(p1.y - p3.y, p1.x - p3.x);
            const angle2 = Math.atan2(p1.y - p2.y, p1.x - p2.x);

            ctx.lineWidth = 5;
            ctx.strokeStyle = 'red';
            ctx.setLineDash([5, 20]);
            ctx.beginPath();
            ctx.moveTo(p1.x * this.pixelPerInch, p1.y * this.pixelPerInch);
            ctx.lineTo(p3.x * this.pixelPerInch, p3.y * this.pixelPerInch);
            ctx.closePath();
            ctx.stroke();

            ctx.beginPath();
            ctx.moveTo(p1.x * this.pixelPerInch, p1.y * this.pixelPerInch);
            ctx.lineTo(p2.x * this.pixelPerInch, p2.y * this.pixelPerInch);
            ctx.closePath();
            ctx.stroke();

            ctx.setLineDash([]);

            const x1 = p1.x + Math.cos(angle1) * distance1;
            const y1 = p1.y + Math.sin(angle1) * distance1;
            const x2 = p1.x + Math.cos(angle2) * distance1;
            const y2 = p1.y + Math.sin(angle2) * distance1;

            ctx.lineWidth = 5;
            ctx.strokeStyle = 'red';
            ctx.beginPath();
            ctx.lineTo(p1.x * this.pixelPerInch, p1.y * this.pixelPerInch);
            ctx.lineTo(x1 * this.pixelPerInch, y1 * this.pixelPerInch);
            ctx.closePath();
            ctx.stroke();
            ctx.beginPath();
            ctx.lineTo(p1.x * this.pixelPerInch, p1.y * this.pixelPerInch);
            ctx.lineTo(x2 * this.pixelPerInch, y2 * this.pixelPerInch);
            ctx.closePath();
            ctx.stroke();

            ctx.fillStyle = 'red';
            ctx.lineWidth = 3;
            ctx.beginPath();
            ctx.arc(p3.x * this.pixelPerInch, p3.y * this.pixelPerInch, 0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.stroke();
            ctx.fill();
            ctx.fillStyle = 'red';
            ctx.lineWidth = 3;
            ctx.beginPath();
            ctx.arc(p2.x * this.pixelPerInch, p2.y * this.pixelPerInch, 0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.stroke();
            ctx.fill();
          }
        }

        const drawJOPMarkers = (side, fill) => {
          ctx.fillStyle = fill;
          side.forEach((jop) => {
            ctx.strokeStyle = jop.patrolMarker != null ? 'white' : 'black';
            const x = jop.x * this.pixelPerInch;
            const y = jop.y * this.pixelPerInch;
            ctx.beginPath();
            ctx.arc(x, y, 1 * this.pixelPerInch, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.stroke();
            ctx.fill();
          });
        };

        drawJOPMarkers(this.attackerJOPs, '#FF000099');
        drawJOPMarkers(this.defenderJOPs, '#0000FF99');

        if (this.markerForJOP != null && this.markerForJOP.patrolMarker != null
            && this.markerForJOP.patrolMarker.closestEnemies != null
            && this.markerForJOP.patrolMarker.closestEnemies[0] != null) {
          ctx.fillStyle = 'red';
          ctx.lineWidth = 3;
          ctx.beginPath();
          ctx.arc(this.markerForJOP.patrolMarker.closestEnemies[0].marker.x * this.pixelPerInch,
              this.markerForJOP.patrolMarker.closestEnemies[0].marker.y * this.pixelPerInch,
              0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.stroke();
          ctx.fill();
        }
        if (this.markerForJOP != null && this.markerForJOP.patrolMarker != null
            && this.markerForJOP.patrolMarker.closestEnemies != null
            && this.markerForJOP.patrolMarker.closestEnemies[1] != null) {
          ctx.fillStyle = 'blue';
          ctx.lineWidth = 3;
          ctx.beginPath();
          ctx.arc(this.markerForJOP.patrolMarker.closestEnemies[1].marker.x * this.pixelPerInch,
              this.markerForJOP.patrolMarker.closestEnemies[1].marker.y * this.pixelPerInch,
              0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.stroke();
          ctx.fill();
        }

      }
      // if (this.xBoundBySecondClosest != null) {
      //   ctx.fillStyle = 'red';
      //   ctx.lineWidth = 3;
      //   ctx.beginPath();
      //   ctx.arc(this.xBoundBySecondClosest, this.yBoundBySecondClosest, 0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
      //   ctx.closePath();
      //   ctx.stroke();
      //   ctx.fill();
      // }
      // if (this.newX != null) {
      //   ctx.fillStyle = 'Black';
      //   ctx.lineWidth = 3;
      //   ctx.beginPath();
      //   ctx.arc(this.newX, this.newY, 0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
      //   ctx.closePath();
      //   ctx.stroke();
      //   ctx.fill();
      // }
      // if (this.intersections != null) {
      //   ctx.fillStyle = 'red';
      //   ctx.lineWidth = 3;
      //   this.intersections.forEach(i => {
      //     ctx.beginPath();
      //     ctx.arc(i.x, i.y, 0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
      //     ctx.closePath();
      //     ctx.stroke();
      //     ctx.fill();
      //   });
      // }
      if (this.misc != null) {
        ctx.fillStyle = 'pink';
        ctx.lineWidth = 3;
        this.misc.forEach(i => {
          ctx.beginPath();
          ctx.arc(i.x, i.y, 0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.stroke();
          ctx.fill();
        });
      }
      // if (this.yIntersect != null) {
      //   ctx.beginPath();
      //   ctx.moveTo(0, this.yIntersect);
      //   ctx.lineTo(this.xIntersect, 0);
      //   ctx.closePath();
      //   ctx.stroke();
      //   ctx.fillStyle = 'green';
      //   ctx.lineWidth = 3;
      //   ctx.beginPath();
      //   ctx.arc(0, this.yIntersect, 0.25 * this.pixelPerInch, 0, Math.PI * 2, true);
      //   ctx.closePath();
      //   ctx.stroke();
      //   ctx.fill();
      // }
    },
    canvasMouseDown(e) {
      const canvasWidth = this.widthInInches * this.pixelPerInch;
      const canvasHeight = this.heightInInches * this.pixelPerInch;
      const bounds = window.document.getElementById('canvas').getBoundingClientRect();
      const relX = e.pageX - bounds.left;
      const relY = e.pageY - bounds.top;
      const percentOfWidth = relX / parseInt(bounds.right - bounds.left, 10);
      const percentOfHeight = relY / parseInt(bounds.bottom - bounds.top, 10);
      const newX = canvasWidth * percentOfWidth;
      const newY = canvasHeight * percentOfHeight;

      if (this.phase === 'JOP') {
        const jopMarkers = this.jopMarkers
            .map(m1 => ({
              marker: m1,
              distance: Math.sqrt(Math.pow(m1.x * this.pixelPerInch - newX, 2) + Math.pow(m1.y * this.pixelPerInch - newY, 2)),
            }))
            .filter(x => x.distance < 1 * this.pixelPerInch)
            .sort((a, b) => a.distance - b.distance);
        if (jopMarkers.length > 0) {
          this.markerForJOP = jopMarkers[0].marker;
          this.markerDraggedFrom = {
            x: this.markerForJOP.x * this.pixelPerInch,
            y: this.markerForJOP.y * this.pixelPerInch,
          };
        }
      }

      const markers = this.markers
          // .filter(m1 => !m1.isLocked)
          .map(m1 => ({
            marker: m1,
            distance: Math.sqrt(Math.pow(m1.x * this.pixelPerInch - newX, 2) + Math.pow(m1.y * this.pixelPerInch - newY, 2)),
          }))
          .filter(x => x.distance < 2 * this.pixelPerInch)
          .sort((a, b) => a.distance - b.distance);
      if (markers.length === 0) {
        return;
      }
      if (markers[0].marker.isLocked) {
        this.lastMarkerClicked = markers[0].marker;
      } else {
        this.markerBeingDragged = markers[0].marker;
        this.markerDraggedFrom = {
          x: this.markerBeingDragged.x * this.pixelPerInch,
          y: this.markerBeingDragged.y * this.pixelPerInch,
        };
      }
    },
    getMaxDistance() {
      if (this.attackerMarkers.includes(this.markerBeingDragged)) {
        return this.attackerMaxDistance;
      } else {
        return this.defenderMaxDistance;
      }
    },
    canvasMouseLeave(e) {
      // console.log('mouseleave');
      this.isDrawingCrosshair = false;
      this.updateCrosshair();
      this.drawImageAndGrid();
      this.canvasMouseUp(e);
    },
    canvasMouseUp(e) {
      if (e == null) {
        return;
      }
      this.newX = null;
      this.newY = null;

      const canvasWidth = this.widthInInches * this.pixelPerInch;
      const canvasHeight = this.heightInInches * this.pixelPerInch;
      const bounds = window.document.getElementById('canvas').getBoundingClientRect();
      const relX = e.pageX - bounds.left;
      const relY = e.pageY - bounds.top;
      const percentOfWidth = relX / parseInt(bounds.right - bounds.left, 10);
      const percentOfHeight = relY / parseInt(bounds.bottom - bounds.top, 10);
      const x = this.widthInInches * percentOfWidth;
      const y = this.heightInInches * percentOfHeight;
      // console.log(`${x},${y}`);

      if (this.phase === 'MOVE_DEFENDER_MARKERS'
          || this.phase === 'MOVE_ATTACKER_MARKERS'
          || this.phase === 'ADD_ATTACKER_JOP'
          || this.phase === 'ADD_DEFENDER_JOP') {
        if (this.phase === 'MOVE_DEFENDER_MARKERS') {
          this.defenderMarkers.forEach(m => {
            m.x = x;
          });
          this.defenderMarkers.forEach(m => {
            m.y = y;
          });
          this.phase = 'PATROL';
        } else if (this.phase === 'MOVE_ATTACKER_MARKERS') {
          this.attackerMarkers.forEach(m => {
            m.x = x;
          });
          this.attackerMarkers.forEach(m => {
            m.y = y;
          });
          this.phase = 'PATROL';
        } else if (this.phase === 'ADD_ATTACKER_JOP') {
          this.jopIndex += 1;
          this.attackerJOPs.push(new JumpOffPoint(this.jopIndex, null, x, y));
          this.phase = 'JOP';
        } else if (this.phase === 'ADD_DEFENDER_JOP') {
          this.jopIndex += 1;
          this.defenderJOPs.push(new JumpOffPoint(this.jopIndex, null, x, y));
          this.phase = 'JOP';
        }
        this.drawImageAndGrid();
        this.pushState();
        return;
      }

      if (this.markerBeingDragged == null && this.markerForJOP == null && this.lastMarkerClicked == null) {
        return;
      }

      if (this.markerBeingDragged != null) {
        if (this.phase === 'PATROL') {
          if (this.closestEnemies.length > 0) {
            this.closestEnemies.filter(x => x.distance < (this.getMaxDistance() + 0.05) * this.pixelPerInch).forEach(x => x.marker.isLocked = true);
            this.markerBeingDragged.isLocked = true;
          }
          this.markerBeingDragged = null;
          this.markerDraggedFrom = null;
          this.friendsWithinMaxDistance = null;


          // Check if one side has locked all their markers
          if (this.attackerMarkers.filter(x => !x.isLocked).length === 0
              || this.defenderMarkers.filter(x => !x.isLocked).length === 0) {
            //
            // Lock all markers
            //
            this.attackerMarkers.forEach((p) => {
              p.isLocked = true;
            });
            this.defenderMarkers.forEach((p) => {
              p.isLocked = true;
            });

            this.phase = 'JOP';
          }
        }
      } else if (this.phase === 'JOP') {
        if (this.lastMarkerClicked == null
            || this.attackerJOPs.find(x => x.patrolMarker === this.lastMarkerClicked) != null
            || this.defenderJOPs.find(x => x.patrolMarker === this.lastMarkerClicked) != null) {
          // Do nothing
        } else {
          this.jopIndex += 1;
          this.markerForJOP = new JumpOffPoint(this.jopIndex, this.lastMarkerClicked);
          let enemyMarkers = null;
          if (this.attackerMarkers.includes(this.lastMarkerClicked)) {
            this.attackerJOPs.push(this.markerForJOP);
            enemyMarkers = this.defenderMarkers;
          } else {
            this.defenderJOPs.push(this.markerForJOP);
            enemyMarkers = this.attackerMarkers;
          }

          this.lastMarkerClicked.closestEnemies = enemyMarkers.map(m => ({
            marker: m,
            distance: Math.hypot((this.lastMarkerClicked.x - m.x) * this.pixelPerInch, (this.lastMarkerClicked.y - m.y) * this.pixelPerInch)
          })).sort((a, b) => a.distance - b.distance);

          const p1 = this.lastMarkerClicked;
          const p2 = this.lastMarkerClicked.closestEnemies[0].marker;
          const p3 = this.lastMarkerClicked.closestEnemies[1].marker;
          const angle1 = Math.atan2(p3.y - p1.y, p3.x - p1.x);
          const angle2 = Math.atan2(p2.y - p1.y, p2.x - p1.x);
          const angle = angle1 - angle2;
          const startAngle = angle2 + Math.PI;
          let a = (angle1 - (startAngle + (angle / 2)));
          const jopMidAngle = Math.abs(a) < Math.PI / 2 || Math.abs(a) > 2 * Math.PI * 0.75
              ? startAngle + (angle / 2) + Math.PI
              : startAngle + (angle / 2);
          const distanceFromMarker = 6;
          const x = Math.cos(jopMidAngle) * distanceFromMarker;
          const y = Math.sin(jopMidAngle) * distanceFromMarker;
          this.markerForJOP.x = Math.min(this.widthInInches, Math.max(0, this.lastMarkerClicked.x + x));
          this.markerForJOP.y = Math.min(this.heightInInches, Math.max(0, this.lastMarkerClicked.y + y));
        }
      }
      this.drawImageAndGrid();

      this.lastMarkerClicked = null;
      this.markerForJOP = null;
      this.pushState();
    },
    processClosestEnemiesForAllMarkers() {
      this.attacker.forEach(markerGroup => {
        markerGroup.patrolMarkers.forEach(patrolMarker => {
          patrolMarker.closestEnemies = this.defenderMarkers.map(m => ({
            marker: m,
            distance: Math.hypot((patrolMarker.x - m.x) * this.pixelPerInch,
                (patrolMarker.y - m.y) * this.pixelPerInch)
          })).sort((a, b) => a.distance - b.distance);
        });
      });
      this.defender.forEach(markerGroup => {
        markerGroup.patrolMarkers.forEach(patrolMarker => {
          patrolMarker.closestEnemies = this.attackerMarkers.map(m => ({
            marker: m,
            distance: Math.hypot((patrolMarker.x - m.x) * this.pixelPerInch,
                (patrolMarker.y - m.y) * this.pixelPerInch)
          })).sort((a, b) => a.distance - b.distance);
        });
      });
    },
    getMarkerGroup(marker) {
      let group = this.attacker.find(g => g.patrolMarkers.some(x => x === marker));
      if (group != null) {
        return group;
      }
      return this.defender.find(g => g.patrolMarkers.some(x => x === marker));
    },
    radToDeg(radians) {
      return radians * (180 / Math.PI);
    },
    canvasMouseMove(e) {
      if (e == null) {
        return;
      }
      this.misc = [];
      const canvasWidth = this.widthInInches * this.pixelPerInch;
      const canvasHeight = this.heightInInches * this.pixelPerInch;
      const bounds = window.document.getElementById('canvas').getBoundingClientRect();
      const relX = e.pageX - bounds.left;
      const relY = e.pageY - bounds.top;
      const percentOfWidth = relX / parseInt(bounds.right - bounds.left, 10);
      const percentOfHeight = relY / parseInt(bounds.bottom - bounds.top, 10);
      let newX = canvasWidth * percentOfWidth;
      let newY = canvasHeight * percentOfHeight;
      const standardMaxDistanceInPixels = 12 * this.pixelPerInch;
      const maxDistanceInPixels = this.getMaxDistance() * this.pixelPerInch;
      this.closestEnemies = [];

      if (this.markerBeingDragged != null && !this.markerBeingDragged.isLocked) {

        // limit newX / newY according to max distance and origin of drag action.
        const distanceFromNewPoint = Math.hypot(newX - this.markerDraggedFrom.x, newY - this.markerDraggedFrom.y);
        if (distanceFromNewPoint > maxDistanceInPixels) {
          let angleFromDragStart = Math.atan((newY - this.markerDraggedFrom.y) / (newX - this.markerDraggedFrom.x));
          if (newX - this.markerDraggedFrom.x < 0) {
            angleFromDragStart -= Math.PI;
          }
          newX = this.markerDraggedFrom.x + maxDistanceInPixels * Math.cos(angleFromDragStart);
          newY = this.markerDraggedFrom.y + maxDistanceInPixels * Math.sin(angleFromDragStart);
        }
        this.newX = newX;
        this.newY = newY;

        let newBoundX = newX;
        let newBoundY = newY;

        // Get other markers in group.
        const otherMarkers = this.getMarkerGroup(this.markerBeingDragged).patrolMarkers.filter(x => x != this.markerBeingDragged);
        // console.log(`other markers: ${otherMarkers.map(x => (x.id + 1)).join(',')}`);

        let closeMarkers = [];
        if (otherMarkers.length > 0) {
          // Measure distance between other markers
          otherMarkers.forEach((m1) => {
            m1.distances = otherMarkers.filter(m2 => m2 !== m1).map((m2) => ({
              marker: m2,
              distance: Math.sqrt(Math.pow(m1.x - m2.x, 2) + Math.pow(m1.y - m2.y, 2)),
            }));
          });

          // Find markers which are no longer in the chain
          const lonelyMarkers = otherMarkers.filter(x => !x.distances.some(d => d.distance <= (this.getMaxDistance() + 0.01)));

          // console.log(`lonelyMarkers: ${lonelyMarkers.length}`);
          if (lonelyMarkers.length === 1) {
            closeMarkers = [...lonelyMarkers, lonelyMarkers[0].distances.sort((a, b) => a.distance - b.distance)[0].marker];
          } else {
            closeMarkers = lonelyMarkers;
          }
          // if (lonelyMarkers.length == 0) {
          //   closeMarkers = [];
          // } else if (lonelyMarkers[0].distances.length > 0) {
          //   closeMarkers = [lonelyMarkers[0], lonelyMarkers[0].distances.sort((a, b) => a.distance - b.distance)[0].marker];
          // } else {
          //   closeMarkers = lonelyMarkers;
          // }

          // console.log(`lonely markers: ${lonelyMarkers.map(x => (x.id + 1)).join(',')}`);
          // console.log(`close markers: ${closeMarkers.map(x => (x.id + 1)).join(',')}`);

          // If no link ends up broken, take the closest marker as constraint.
          if (closeMarkers.length === 0) {
            closeMarkers.push(otherMarkers.map(m2 => ({
              marker: m2,
              distance: Math.sqrt(Math.pow(this.markerBeingDragged.x - m2.x, 2) + Math.pow(this.markerBeingDragged.y - m2.y, 2)),
            })).sort((a, b) => a.distance - b.distance)[0].marker);
          }
          this.closestMarkers = closeMarkers;
          // if (closeMarkers.length > 1) {
          //   this.closestMarkers = closeMarkers;
          // } else {
          //   this.closestMarkers = [...closeMarkers, { x: this.markerDraggedFrom.x / this.pixelPerInch, y: this.markerDraggedFrom.y / this.pixelPerInch }];
          // }
        } else {
          this.closestMarkers = [{ x: this.markerDraggedFrom.x / this.pixelPerInch, y: this.markerDraggedFrom.y / this.pixelPerInch }];
        }


        const maxDistInPixels = this.getMaxDistance() * this.pixelPerInch;

        //
        // Check for collisions with enemy.
        //
        const enemyMarkers = this.attackerMarkers.includes(this.markerBeingDragged)
            ? this.defenderMarkers
            : this.attackerMarkers;

        //
        // Find closest enemies
        //
        this.closestEnemies = enemyMarkers
            .map(m => ({
              marker: m,
              distance: Math.hypot(newX - m.x * this.pixelPerInch, newY - m.y * this.pixelPerInch)
            }))
            .filter(x => x.distance <= (standardMaxDistanceInPixels + 0.01))
            .sort((a, b) => a.distance - b.distance);
        // console.log(`this.closestEnemies.length: ${this.closestEnemies.length}`);
        if (this.closestEnemies.length > 1) {
          const intersections = this.getIntersection(
              this.closestEnemies[0].marker.x * this.pixelPerInch,
              this.closestEnemies[0].marker.y * this.pixelPerInch,
              standardMaxDistanceInPixels,
              this.closestEnemies[1].marker.x * this.pixelPerInch,
              this.closestEnemies[1].marker.y * this.pixelPerInch,
              standardMaxDistanceInPixels);
          const hypo1 = Math.hypot(newX - intersections[0].x,
              newY - intersections[0].y);
          const hypo2 = Math.hypot(newX - intersections[1].x,
              newY - intersections[1].y);

          if (hypo1 > hypo2) {
            newBoundX = intersections[1].x;
            newBoundY = intersections[1].y;
          } else {
            newBoundX = intersections[0].x;
            newBoundY = intersections[0].y;
          }
        } else if (this.closestEnemies.length > 0) {
          const [closestEnemy] = this.closestEnemies;
          const closestEnemyX = closestEnemy.marker.x * this.pixelPerInch;
          const closestEnemyY = closestEnemy.marker.y * this.pixelPerInch;

          // this.misc.push({ x: this.markerDraggedFrom.x, y: this.markerDraggedFrom.y });
          // this.misc.push({ x: newX, y: newY });

          const slope = (newY - this.markerDraggedFrom.y) / (newX - this.markerDraggedFrom.x);
          const slopeAngle = Math.atan(slope);
          this.yIntersect = this.markerDraggedFrom.y - slope * this.markerDraggedFrom.x;
          this.xIntersect = -this.yIntersect / slope;
          // console.log(slope);
          // console.log(this.xIntersect);

          this.intersections = this.findCircleLineIntersections(
              standardMaxDistanceInPixels,
              closestEnemyX,
              closestEnemyY,
              slope,
              this.yIntersect,
          ).reduce((mem, x, i) => {
            mem.push({ x, y: x * slope + this.yIntersect });
            return mem;
          }, []);

          if (this.intersections.length > 0) {
            const [first] = this.intersections.sort((a, b) => {
              return Math.hypot(a.x - this.markerDraggedFrom.x, a.y - this.markerDraggedFrom.y)
                  - Math.hypot(b.x - this.markerDraggedFrom.x, b.y - this.markerDraggedFrom.y);
            });
            newBoundX = first.x;
            newBoundY = first.y;
          }
          //console.log(`this.intersections.length: ${this.intersections.length}`);
          // let angle3 = Math.atan((newY - closestEnemyY) / (newX - closestEnemyX));
          // if (newX - closestEnemyX < 0) {
          //   angle3 -= Math.PI;
          // }
          // const hyp3 = Math.sqrt(Math.pow(newX - closestEnemyX, 2) + Math.pow(newY - closestEnemyY, 2));
          // const offsetX3 = Math.min(standardMaxDistanceInPixels, hyp3 - standardMaxDistanceInPixels) * Math.cos(angle3);
          // const offsetY3 = Math.min(standardMaxDistanceInPixels, hyp3 - standardMaxDistanceInPixels) * Math.sin(angle3);
          //
          // newBoundX -= offsetX3;
          // newBoundY -= offsetY3;
          // console.log(`hyp3: ${hyp3}, offsetX3: ${offsetX3}, offsetY3: ${offsetY3}`);
        }

        //
        // Constrain the new coordinates so that they are 12" away from the closest enemy
        //
        const candidateCoordinates = [];

        this.closestMarkers.forEach((closeMarker, i) => {
          const closestPositionInPixels = {
            x: closeMarker.x * this.pixelPerInch,
            y: closeMarker.y * this.pixelPerInch,
          };
          let angleToCloseMarker = Math.atan((newBoundY - closestPositionInPixels.y) / (newBoundX - closestPositionInPixels.x));
          if (newBoundX - closestPositionInPixels.x < 0) {
            angleToCloseMarker -= Math.PI;
          }

          const distanceToCloseMarker = Math.sqrt(Math.pow(newBoundX - closestPositionInPixels.x, 2) + Math.pow(newBoundY - closestPositionInPixels.y, 2));
          if (distanceToCloseMarker > maxDistInPixels) {
            const offsetFromCloseMarkerBoundByMaxDistance = {
              x: Math.min(maxDistInPixels, distanceToCloseMarker) * Math.cos(angleToCloseMarker),
              y: Math.min(maxDistInPixels, distanceToCloseMarker) * Math.sin(angleToCloseMarker),
            };
            const boundByCloseMarker = {
              x: offsetFromCloseMarkerBoundByMaxDistance.x + closestPositionInPixels.x,
              y: offsetFromCloseMarkerBoundByMaxDistance.y + closestPositionInPixels.y,
            };

            // const distanceBoundByCloseMarker = Math.sqrt(
            //     Math.pow(boundByCloseMarker.x - closestPositionInPixels.x, 2)
            //     + Math.pow(boundByCloseMarker.y - closestPositionInPixels.y, 2));

            // newBoundX = boundByCloseMarker.x;
            // newBoundY = boundByCloseMarker.y;
            candidateCoordinates.push({
              distance: distanceToCloseMarker,
              pos: boundByCloseMarker,
              isEnemy: this.closestMarkers.length - 1 === i ? null : false,
              origin: closestPositionInPixels,
            });
          }
        });

        this.friendsWithinMaxDistance = otherMarkers
            .filter(m => Math.hypot(m.x - this.markerBeingDragged.x, m.y - this.markerBeingDragged.y) <= this.getMaxDistance());

        const distanceToStartPoint = 0;
        // const distanceToStartPoint = Math.hypot(newBoundX - this.markerDraggedFrom.x, newBoundY - this.markerDraggedFrom.y);

        if (candidateCoordinates.length > 0) {
          // console.log(`closestMarkers: ${this.closestMarkers.length}`);
          // console.log(`candidateCoordinates: ${candidateCoordinates.length}`);
          const friendCandidateCoordinates = candidateCoordinates;
          // console.log(`friendCandidateCoordinates: ${friendCandidateCoordinates.length}`);
          if (friendCandidateCoordinates.length > 1) {
            const intersections = this.getIntersection(
                friendCandidateCoordinates[0].origin.x,
                friendCandidateCoordinates[0].origin.y,
                standardMaxDistanceInPixels,
                distanceToStartPoint > maxDistInPixels ? this.markerDraggedFrom.x : friendCandidateCoordinates[friendCandidateCoordinates.length - 1].origin.x,
                distanceToStartPoint > maxDistInPixels ? this.markerDraggedFrom.y : friendCandidateCoordinates[friendCandidateCoordinates.length - 1].origin.y,
                standardMaxDistanceInPixels);
            const hypo1 = Math.hypot(newX - intersections[0].x,
                newY - intersections[0].y);
            const hypo2 = Math.hypot(newX - intersections[1].x,
                newY - intersections[1].y);

            if (hypo1 > hypo2) {
              newBoundX = intersections[1].x;
              newBoundY = intersections[1].y;
            } else {
              newBoundX = intersections[0].x;
              newBoundY = intersections[0].y;
            }
            this.intersections = intersections;
          } else {
            const [furthest] = [...friendCandidateCoordinates].sort((a, b) => b.distance - a.distance);
            newBoundX = furthest.pos.x;
            newBoundY = furthest.pos.y;
            // console.log(`${newBoundX}, ${newBoundY}`);
          }
        }

        if (newBoundX != null && newBoundY != null && !Number.isNaN(newBoundX) && !Number.isNaN(newBoundY)) {
          this.markerBeingDragged.x = Math.min(Math.max(0, newBoundX), canvasWidth) / this.pixelPerInch;
          this.markerBeingDragged.y = Math.min(Math.max(0, newBoundY), canvasHeight) / this.pixelPerInch;
        }
      } else if (this.markerForJOP != null) {
        const p1 = this.markerForJOP.patrolMarker;
        const cursorX = Math.min(this.widthInInches, Math.max(0, newX / this.pixelPerInch));
        const cursorY = Math.min(this.heightInInches, Math.max(0, newY / this.pixelPerInch));
        let jopX = cursorX;
        let jopY = cursorY;
        if (p1 != null) {
          const p2 = this.markerForJOP.patrolMarker.closestEnemies[0].marker;
          const p3 = this.markerForJOP.patrolMarker.closestEnemies[1].marker;
          let angle1 = Math.atan2(p1.y - p3.y, p1.x - p3.x);
          let angle2 = Math.atan2(p1.y - p2.y, p1.x - p2.x);
          let distanceFromPatrolMarker = Math.sqrt((p1.x - jopX) ** 2 + (p1.y - jopY) ** 2);

          let angle3 = Math.atan2(jopY - p1.y, jopX - p1.x);

          if (angle1 > angle2) {
            const a = angle1;
            angle1 = angle2;
            angle2 = a;
          }
          // console.log(`angle 1: ${this.radToDeg(angle1)}`);
          // console.log(`angle 2: ${this.radToDeg(angle2)}`);
          // console.log(`angle 3: ${this.radToDeg(angle3)}`);

          // console.log(distanceFromPatrolMarker)
          if (distanceFromPatrolMarker < 6) {
            distanceFromPatrolMarker = 6;
            jopX = p1.x + Math.cos(angle3) * 6;
            jopY = p1.y + Math.sin(angle3) * 6;
            // console.log(`${jopX}, ${jopY}`);
          }

          if (angle1 < -Math.PI / 2 && angle2 > Math.PI / 2) {
            if (angle3 < 0 && angle3 > angle1) {
              console.log('angle3 < 0 && angle3 > angle1');
              jopX = p1.x + Math.cos(angle1) * distanceFromPatrolMarker;
              jopY = p1.y + Math.sin(angle1) * distanceFromPatrolMarker;
            } else if (angle3 > 0 && angle3 < angle2) {
              console.log('angle3 > 0 && angle3 < angle2');
              jopX = p1.x + Math.cos(angle2) * distanceFromPatrolMarker;
              jopY = p1.y + Math.sin(angle2) * distanceFromPatrolMarker;
            }
          } else {
            const toTop = p1.y;
            const toBottom = this.heightInInches - p1.y;
            const toLeft = p1.x;
            const toRight = this.widthInInches - p1.x;
            const min = Math.min(toTop, toBottom, toLeft, toRight);
            if (angle3 < angle1) {
              console.log('angle3 < angle1');
              // if (toTop === min) {
              //   distanceFromPatrolMarker = Math.min(distanceFromPatrolMarker, toTop / Math.sin(angle1));
              // } else if (toBottom == min) {
              //   distanceFromPatrolMarker = Math.min(distanceFromPatrolMarker, toBottom / Math.sin(angle1));
              // } else if (toLeft === min) {
              //   distanceFromPatrolMarker = Math.min(distanceFromPatrolMarker, toLeft / Math.cos(angle1));
              // } else if (toRight == min) {
              //   distanceFromPatrolMarker = Math.min(distanceFromPatrolMarker, toRight / Math.cos(angle1));
              // }
              jopX = p1.x + Math.cos(angle1) * distanceFromPatrolMarker;
              jopY = p1.y + Math.sin(angle1) * distanceFromPatrolMarker;
            } else if (angle3 > angle2) {
              console.log('angle3 > angle2');
              // const maxDistance = Math.min((cursorX - p1.x) * Math.cos(angle2), (cursorY - p1.y) * Math.sin(angle2));
              // if (toTop === min) {
              //   distanceFromPatrolMarker = Math.min(distanceFromPatrolMarker, toTop / Math.sin(angle2));
              // } else if (toBottom == min) {
              //   distanceFromPatrolMarker = Math.min(distanceFromPatrolMarker, toBottom / Math.sin(angle2));
              // } else if (toLeft === min) {
              //   distanceFromPatrolMarker = Math.min(distanceFromPatrolMarker, toLeft / Math.cos(angle2));
              // } else if (toRight == min) {
              //   distanceFromPatrolMarker = Math.min(distanceFromPatrolMarker, toRight / Math.cos(angle2));
              // }
              // console.log(this.randomPoint);
              jopX = p1.x + Math.cos(angle2) * distanceFromPatrolMarker;
              jopY = p1.y + Math.sin(angle2) * distanceFromPatrolMarker;
            }
          }
        }
        this.markerForJOP.x = Math.min(this.widthInInches, Math.max(0, jopX));
        this.markerForJOP.y = Math.min(this.heightInInches, Math.max(0, jopY));
      }

      this.drawImageAndGrid();
      if (this.markerBeingDragged == null) {
        this.updateCrosshair(e);
      }
    },
    findCircleLineIntersections(r, h, k, m, n) {
      // circle: (x - h)^2 + (y - k)^2 = r^2
      // line: y = m * x + n
      // r: circle radius
      // h: x value of circle centre
      // k: y value of circle centre
      // m: slope
      // n: y-intercept

      // console.log(`r:${r}, h:${h}, k;${k}, m:${m}, n:${n}`);

      const sq = x => x * x;
      const sqrt = x => Math.sqrt(x);

      // get a, b, c values
      const a = 1 + sq(m);
      const b = -h * 2 + (m * (n - k)) * 2;
      const c = sq(h) + sq(n - k) - sq(r);

      // get discriminant
      const d = sq(b) - 4 * a * c;
      if (d >= 0) {
        // insert into quadratic formula
        const intersections = [
          (-b + sqrt(sq(b) - 4 * a * c)) / (2 * a),
          (-b - sqrt(sq(b) - 4 * a * c)) / (2 * a)
        ];
        if (d === 0) {
          // only 1 intersection
          return [intersections[0]];
        }
        return intersections;
      }
      // no intersection
      return [];
    },
    getIntersection(x0, y0, r0, x1, y1, r1) {
      let a,
          dx,
          dy,
          d,
          h,
          rx,
          ry;
      let x2,
          y2;

      // dx and dy are the vertical and horizontal distances between
      // the circle centers.
      dx = x1 - x0;
      dy = y1 - y0;

      // Determine the straight-line distance between the centers.
      d = Math.sqrt((dy * dy) + (dx * dx));

      // Check for solvability.
      if (d > (r0 + r1)) {
        // no solution. circles do not intersect.
        return false;
      }
      if (d < Math.abs(r0 - r1)) {
        // no solution. one circle is contained in the other
        return false;
      }

      // 'point 2' is the point where the line through the circle
      // getIntersection points crosses the line between the circle
      // centers.

      // Determine the distance from point 0 to point 2.
      a = ((r0 * r0) - (r1 * r1) + (d * d)) / (2.0 * d);

      // Determine the coordinates of point 2.
      x2 = x0 + (dx * a / d);
      y2 = y0 + (dy * a / d);

      // Determine the distance from point 2 to either of the
      // getIntersection points.
      h = Math.sqrt((r0 * r0) - (a * a));

      // Now determine the offsets of the getIntersection points from
      // point 2.
      rx = -dy * (h / d);
      ry = dx * (h / d);

      // Determine the absolute getIntersection points.
      const xi = x2 + rx;
      const xi_prime = x2 - rx;
      const yi = y2 + ry;
      const yi_prime = y2 - ry;

      return [{ x: xi, y: yi }, { x: xi_prime, y: yi_prime }];
    },
    updateCrosshair(e) {
      if (!this.isDrawingCrosshair || e == null) {
        return;
      }
      const canvas = document.getElementById('canvas');
      const ctx = canvas.getContext('2d');
      const bounds = e.target.getBoundingClientRect();
      const relX = e.pageX - bounds.left;
      const relY = e.pageY - bounds.top;
      const percentOfWidth = relX / parseInt(bounds.right - bounds.left, 10);
      const percentOfHeight = relY / parseInt(bounds.bottom - bounds.top, 10);
      ctx.strokeStyle = 'cyan';
      ctx.lineWidth = 3;
      ctx.beginPath();
      const fractionOfAnInch = 4;
      const xStep = (canvas.width / this.widthInInches) / fractionOfAnInch;
      const yStep = (canvas.height / this.heightInInches) / fractionOfAnInch;
      const xInch = Math.round(canvas.width * percentOfWidth / xStep) / fractionOfAnInch;
      const yInch = Math.round(canvas.height * percentOfHeight / yStep) / fractionOfAnInch;
      const x = xInch * xStep * fractionOfAnInch;
      const y = yInch * yStep * fractionOfAnInch;
      ctx.moveTo(x, 0);
      ctx.lineTo(x, canvas.height);
      ctx.moveTo(0, y);
      ctx.lineTo(canvas.width, y);
      ctx.closePath();
      ctx.stroke();
      ctx.font = `${canvas.width / canvas.clientWidth * 16}px sans-serif`;
      const xText = `${xInch}"`;
      const text = `${xText} x ${yInch}"`;
      const textWidth = ctx.measureText(text);
      const xOffset = xInch > 36 ? -(xStep * fractionOfAnInch + textWidth.width) : xStep * fractionOfAnInch;
      const yOffset = yInch > 24 ? -yStep * fractionOfAnInch : 2 * fractionOfAnInch * yStep;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.shadowColor = 'rgba(0,0,0,0.9)';
      ctx.shadowBlur = 20;
      ctx.fillStyle = '#fff';
      ctx.beginPath();
      ctx.fillText(text, x + xOffset, y + yOffset);
      ctx.closePath();
    },
    handleFileUpload(e) {
      const vue = this;
      if (e.target.files && e.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const imageData = e.target.result;
          const image = new Image();
          image.onload = () => {
            vue.image = image;
            setTimeout(() => {
              vue.drawImageAndGrid();
            }, 100);
          };
          image.src = imageData;
        };

        reader.readAsDataURL(e.target.files[0]); // convert to base64 string
      }
    },
    downloadImage() {
      var link = document.createElement('a');
      link.download = 'map.jpg';
      link.href = document.getElementById('canvas').toDataURL('image/jpeg');
      link.click();
    },
    addMarkers(markerGroup, quantity = 4, spacing = 6) {
      for (let id = 0; id < quantity; id += 1) {
        switch (markerGroup.tableEdge) {
          case TableEdges.W: {
            const y = (this.heightInInches / 2) - ((quantity - 1) * spacing / 2) + (id * spacing);
            markerGroup.patrolMarkers.push(new PatrolMarker(id, 0, y));
            break;
          }
          case TableEdges.E: {
            const y = (this.heightInInches / 2) - ((quantity - 1) * spacing / 2) + (id * spacing);
            markerGroup.patrolMarkers.push(new PatrolMarker(id, this.widthInInches, y));
            break;
          }
          case TableEdges.N: {
            const x = (this.widthInInches / 2) - ((quantity - 1) * spacing / 2) + (id * spacing);
            markerGroup.patrolMarkers.push(new PatrolMarker(id, x, 0));
            break;
          }
          case TableEdges.S: {
            const x = (this.widthInInches / 2) - ((quantity - 1) * spacing / 2) + (id * spacing);
            markerGroup.patrolMarkers.push(new PatrolMarker(id, x, this.heightInInches));
            break;
          }
        }
      }
    },
    addMarkerGroup(side) {
      const tableEdge = TableEdges.getAdjacentEdge(side[0].tableEdge);
      side.push(new MarkerGroup([], tableEdge));
    },
    removeMarkerGroup(markerGroup) {
      this.attacker = this.attacker.filter(x => x !== markerGroup);
      this.defender = this.defender.filter(x => x !== markerGroup);
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    moveDefenderMarkers() {
      this.phase = 'MOVE_DEFENDER_MARKERS';
    },
    moveAttackerMarkers() {
      this.phase = 'MOVE_ATTACKER_MARKERS';
    },
    addAttackerJOP() {
      this.phase = 'ADD_ATTACKER_JOP';
    },
    addDefenderJOP() {
      this.phase = 'ADD_DEFENDER_JOP';
    },
    rollDice(diceCount) {
      const dice = [];
      for (let i = 0; i < diceCount; i += 1) {
        dice.push(1 + Math.floor(Math.random() * 6));
      }
      this.dice = dice;
      // console.log(this.dice.join(','));
    },
    onWindowResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
      this.isPortrait = (window.innerWidth / window.innerHeight) > 1.5;
    },
  },
  watch: {
    widthInInches() {
      this.drawImageAndGrid();
    },
    heightInInches() {
      this.drawImageAndGrid();
    },
    image() {
      if (this.image != null && this.attackerMarkers.length === 0) {
        this.addMarkers(this.attacker[0], 4);

        this.addMarkers(this.defender[0], 4);

        this.drawImageAndGrid();
      }
    },
    isShadedAreaEnabled(val) {
      if (val) {
        this.shadedArea = new ShadedArea(6, 6, 6, 36);
      } else {
        this.shadedArea = null;
      }
    },
  },
  mounted() {
    const image = new Image();
    image.onload = () => {
      this.image = image;
      this.drawImageAndGrid();
    };
    image.src = 'assets/map.png';

    this.isPortrait = (window.innerWidth / window.innerHeight) > 1.5;

    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;

    window.addEventListener('resize', () => {
      this.onWindowResize();
    });

    window.addEventListener('mouseup', () => {
      this.canvasMouseUp();
    });

    if (window.localStorage.states != null) {
      this.states = JSON.parse(window.localStorage.states);
      if (window.localStorage.redoStates != null) {
        this.redoStates = JSON.parse(window.localStorage.redoStates);
      }
      this.applyState();
      this.processClosestEnemiesForAllMarkers();
    } else {
      this.pushState();
    }
    this.isLoaded = true;

    setTimeout(this.onWindowResize, 200);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.modal {
  position: fixed;
  margin: 5vh -25vw;
  left: 50%;
  width: 50vw;
  z-index: 10;
  display: flex;
  flex-direction: column;
  background: #eee;
  border-radius: 1vw;
  overflow: hidden;
  box-shadow: 0 1vw 2vw #00000044;

  .form {
    flex-direction: column;
    align-items: flex-start;
    display: flex;
    justify-content: stretch;
    padding: 2.4vw;

    > * {
      margin-bottom: 0.5rem;
    }

    .separator {
      font-family: 'Carter One';
    }

    label {
      margin-right: 0;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      width: 100%;

      span {
        flex-grow: 1;
      }
    }

    .buttons {
      display: flex;
      align-items: center;
      margin-top: 0.6rem;
      margin-bottom: 0;
    }

    button, .upload {
      width: 9rem;
      margin-right: 1rem;
    }
  }

  table {
    width: 100%;
    border: solid 1px #ddd;

    td, th {
      padding: 0.3rem 0.8rem;
    }

    th {
      border-bottom: solid 1px #ddd;
    }

    button {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2rem !important;
      height: 1.9rem;

      svg {
        margin-right: 0;
      }
    }
  }
}

.veil {
  background: #00000033;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
}

input[type=number] {
  margin-left: 8px;
  width: 50px;
  padding: 3px;
  //font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;

}

input[type=number] {
  height: 24px;
  padding: 3px 10px;
  width: 56px;
}

input[type=text],
select {
  height: 33px;
  padding: 3px 10px;
  width: 80px;
}

.form {
  padding: 12px 16px;
  //border-radius: 0 0 3px ;
  //margin: 16px;
  background: #ffffffee;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5vw 5vw #00000066;

  label {
    margin-right: 30px;
    font-size: 14px;

    span {
      flex-grow: 1;
      text-align: left;
    }


    &.upload {
      input {
        opacity: 0;
        width: 0px;
        height: 0px;
        display: none;
      }
    }
  }

  .upload,
  button {
    font-size: 14px;
    padding: 7px 12px;
    outline: none;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: all .2s ease-in-out;
    background: #3A3B39;
    color: #ffffffee;
    display: flex;
    align-items: center;
    margin-right: 16px;
    box-shadow: 0 2px 5px #00000033;
    text-shadow: 0 -1px 0px #000000;
    font-family: 'Carter One', sans-serif;
    position: relative;

    .menu-bg {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: #00000001;
      z-index: 1;
      cursor: pointer;
      pointer-events: all;
    }

    ul {
      background: #fff;
      color: #3A3B39;
      position: absolute;
      top: 2rem;
      right: 0;
      z-index: 2;
      width: 15rem;
      margin: 0.6rem 0 0;
      box-shadow: 0 2px 4px #00000033;
      border-radius: 4px;
      list-style: none;
      font-family: 'Karla', sans-serif;
      font-size: 1rem;
      padding: 0.3rem 0;

      li {
        padding: 0.5rem 1.2rem;
        text-align: left;

        &:hover {
          background: #00000011;
        }
      }
    }

    svg {
      fill: #ffffffee;
      fill-rule: evenodd;
      height: 1rem;
      width: 1rem;
      margin-right: 0.5rem;
    }

    &.disabled {
      background: #ccc;
      text-shadow: 0 -1px 0px #00000033;
    }

    &.muted {
      background: #fff;
      color: #3A3B39;
      border: solid 1px #cac8c8;
      text-shadow: 0 -1px 0px #00000033;

      svg {
        fill: #3A3B39;
      }
    }
  }

  .upload {
    margin-right: 0;
  }
}


.map {
  label {
    background: #eee;
    position: fixed;
    top: 50%;
    left: 50%;
    font-size: 3vw;
    padding: 16px;
    width: 50vw;
    height: 20vh;
    margin-left: -25vw;
    margin-top: -10vh;
    border-radius: 1vw;
    border: solid 2px #111;
    box-shadow: 0 5vw 5vw #00000066;
    outline: none;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    transition: all .2s ease-in-out;

    &:hover,
    &:active {
      background: #fff;
    }

    input {
      opacity: 0;
      width: 0px;
      height: 0px;
    }
  }
}

.shaded-area-inputs {
  span {
    margin-left: 1.2rem;
  }

  input {
    width: 2.4rem;
  }
}

.dice {
  display: flex;
  align-items: center;
  margin-top: 4px;

  .die {
    img {
      height: 2rem;
      width: 2rem;
    }
  }
}
</style>
